export default __webpack_public_path__ + "static/Audio-45be507b5dbdef917851d9762a1db271.png";